// create and export lib object container
import buildOC from "./ioc.js";
const libOC = buildOC();
export default libOC;

// export individual components
import DataUrlGeneratorInterface from "./dataUrlGenerator/DataUrlGeneratorInterface.js";
import DataUrlBase64Generator from "./dataUrlGenerator/DataUrlBase64Generator.js";

import EnvDecisionInterface from "./env/EnvDecision/EnvDecisionInterface.js";
import EnvDecisionDomain from "./env/EnvDecision/EnvDecisionDomain.js";
import EnvStorageInterface from "./env/EnvStorage/EnvStorageInterface.js";
import EnvStorage from "./env/EnvStorage/EnvStorage.js";
import EnvStorageValueGetterInterface from "./env/EnvStorageValueGetter/EnvStorageValueGetterInterface.js";
import EnvStorageValueGetter from "./env/EnvStorageValueGetter/EnvStorageValueGetter.js";

import ImageUrlProcurerInterface from "./imageUrlProcurer/ImageUrlProcurerInterface.js";
import ImageUrlProcurer from "./imageUrlProcurer/ImageUrlProcurer.js";

import Logger from "./logger/Logger.js";
import LoggerDateTimeDecorator from "./logger/decorator/LoggerDateTimeDecorator.js";

import buildEmptyObjectContainer from "./objectContainer/buildEmptyObjectContainer.js";
import ObjectContainer from "./objectContainer/ObjectContainer.js";
import ObjectContainerService from "./objectContainer/ObjectContainerService.js";
import ObjectStorageStrategy from "./objectContainer/ObjectStorageStrategy.js";

import Getter from "./getter/Getter.js";

import Storage from "./storage/Storage.js";

import ConfigStorage from "./storage/configStorage/ConfigStorage.js";

import SharedStorageInterface from "./storage/sharedStorage/SharedStorageInterface.js";
import SharedStorageAgentInterface from "./storage/sharedStorage/SharedStorageAgentInterface.js";
import SharedStorageSubscribeStrategyInterface from "./storage/sharedStorage/SharedStorageSubscribeStrategyInterface.js";
import SharedStorageInitValue from "./storage/sharedStorage/SharedStorageInitValue.js";
import SharedStoragePersistDecorator from "./storage/sharedStorage/SharedStoragePersistDecorator.js";
import SharedStorageMock from "./storage/sharedStorage/mock/SharedStorageMock.js";

import SharedStorageRedux from "./storage/sharedStorage/redux/SharedStorageRedux.js";
import SharedStorageAgentRedux from "./storage/sharedStorage/redux/SharedStorageAgentRedux.js";
import SharedStorageSubscribeStrategyRedux from "./storage/sharedStorage/redux/SharedStorageSubscribeStrategyRedux.js";
import SharedStorageReduxReducersGenerator from "./storage/sharedStorage/redux/SharedStorageReduxReducersGenerator.js";

import SharedStorageQiankun from "./storage/sharedStorage/qiankun/SharedStorageQiankun.js";
import SharedStorageAgentQiankun from "./storage/sharedStorage/qiankun/SharedStorageAgentQiankun.js";
import SharedStorageAgentSubscribeWrapperQiankun from "./storage/sharedStorage/qiankun/SharedStorageAgentSubscribeWrapperQiankun.js";
import SharedStorageGlobalSubscribeStrategyQiankun from "./storage/sharedStorage/qiankun/SharedStorageGlobalSubscribeStrategyQiankun.js";

import ValueComparer from "./valueComparer/ValueComparer.js";

export {
    DataUrlGeneratorInterface,
    DataUrlBase64Generator,
    EnvDecisionInterface,
    EnvDecisionDomain,
    EnvStorageInterface,
    EnvStorage,
    EnvStorageValueGetterInterface,
    EnvStorageValueGetter,
    ImageUrlProcurerInterface,
    ImageUrlProcurer,
    Logger,
    LoggerDateTimeDecorator,
    buildEmptyObjectContainer,
    ObjectContainer,
    ObjectContainerService,
    ObjectStorageStrategy,
    Getter,
    Storage,
    ConfigStorage,
    SharedStorageInterface,
    SharedStorageAgentInterface,
    SharedStorageSubscribeStrategyInterface,
    SharedStorageInitValue,
    SharedStoragePersistDecorator,
    SharedStorageMock,
    SharedStorageRedux,
    SharedStorageAgentRedux,
    SharedStorageSubscribeStrategyRedux,
    SharedStorageReduxReducersGenerator,
    SharedStorageQiankun,
    SharedStorageAgentQiankun,
    SharedStorageAgentSubscribeWrapperQiankun,
    SharedStorageGlobalSubscribeStrategyQiankun,
    ValueComparer
}